import { render, staticRenderFns } from "./examineList.vue?vue&type=template&id=21f7a556&scoped=true"
import script from "./examineList.vue?vue&type=script&lang=js"
export * from "./examineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f7a556",
  null
  
)

export default component.exports